<template>
  <div class="tp-container">
    <div class="title">
      <div>{{ item.name }}</div>
      <div>
        <span ref="number">{{ item.number }}</span>
        张
      </div>
    </div>
    <div class="tp-chart" ref="myChart"></div>
  </div>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(() => {
        this.init()
      })
    },
    beforeDestroy() {
      this.$animejs.remove([this.$refs.number])
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let option
        let chartdata = [this.item.number]
        let max = this.item.total
        option = {
          grid: {
            top: 0,
            left: '2%',
            right: '5%',
            bottom: 0,
            containLabel: true,
          },
          xAxis: {
            type: 'value',
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            max: max,
          },
          yAxis: {
            type: 'category',
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
          series: [
            {
              type: 'bar',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: this.item.color[0],
                    },
                    {
                      offset: 1,
                      color: this.item.color[1],
                    },
                  ]),
                  opacity: 0.7,
                  barBorderRadius: 4,
                },
              },
              label: {
                show: true,
                formatter: '',
                backgroundColor: '#fff',
                width: 8,
                height: 8,
                position: 'right',
                offset: [-7, 0],
                borderWidth: 5,
                borderColor: 'rgba(255,255,255,0.2)',
                borderRadius: 5,
                shadowColor: '#fff',
                shadowBlur: 10,
              },
              showBackground: true,
              silent: true,
              barWidth: 5,
              barGap: '-100%', // Make series be overlap
              data: [chartdata],
            },
          ],
        }
        myChart.setOption(option)
        // 数字滚动动画
        this.$animejs({
          targets: this.$refs.number,
          innerHTML: [0, this.item.number],
          cycles: 130,
          round: 1,
          easing: 'linear',
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tp-container {
    .title {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      color: white;
      font-size: 16px;
      padding: 0 1.25vh;
    }
    .tp-chart {
      width: 100%;
      height: 4vh;
    }
  }
</style>
